// Placeholder for utility functions
export const formatDate = (date: Date) => date.toISOString();
export { getFirebaseAuthErrorMessage } from './firebaseAuthErrors';
export { describeReward, formatMoney, type RewardPart } from './rewardFormat';
export { bugReporterActionLog, createBugReporterMiddleware } from './bug-reporter';
export {
  playNotificationSound,
  setDocumentTitleWithCount,
  requestNotificationPermission,
  showBrowserNotification,
  canRequestNotificationPermission,
} from './notificationUtils';

/**
 * Extracts hostname from a URL and returns the icon.horse favicon URL.
 * e.g. https://www.example.com/path -> https://icon.horse/icon/www.example.com
 */
export function getIconHorseUrl(url: string): string {
  if (!url?.trim()) return '';
  try {
    const parsed = new URL(url.trim());
    const hostname = parsed.hostname;
    return hostname ? `https://icon.horse/icon/${hostname}` : '';
  } catch {
    return '';
  }
}
